module.exports = __webpack_public_path__ + "static/img/X5按键面板.8a5e8d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-1-model/X5按键面板.png
// module id = d595
// module chunks = 0